function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LayersComponent from '../../components/Layers/Layers';
import { toggleLayer as _toggleLayer } from '../../store/actions/mapSlice';
var Layers = function Layers(props) {
  var dispatch = useDispatch();
  var group = props.group;
  var layers = [];
  var activeLayers = [];
  switch (group) {
    case 'secondary':
      layers = useSelector(function (state) {
        var _state$app, _state$app$project, _state$app$project$co;
        return state === null || state === void 0 ? void 0 : (_state$app = state.app) === null || _state$app === void 0 ? void 0 : (_state$app$project = _state$app.project) === null || _state$app$project === void 0 ? void 0 : (_state$app$project$co = _state$app$project.configs) === null || _state$app$project$co === void 0 ? void 0 : _state$app$project$co.secondaryLayers;
      });
      activeLayers = useSelector(function (state) {
        var _state$app2, _state$app2$activeLay;
        return state === null || state === void 0 ? void 0 : (_state$app2 = state.app) === null || _state$app2 === void 0 ? void 0 : (_state$app2$activeLay = _state$app2.activeLayers) === null || _state$app2$activeLay === void 0 ? void 0 : _state$app2$activeLay.secondary;
      });
      break;
    case 'basemap':
      layers = useSelector(function (state) {
        var _state$app3;
        return state === null || state === void 0 ? void 0 : (_state$app3 = state.app) === null || _state$app3 === void 0 ? void 0 : _state$app3.basemaps;
      });
      activeLayers = useSelector(function (state) {
        var _state$app4, _state$app4$activeLay;
        return state === null || state === void 0 ? void 0 : (_state$app4 = state.app) === null || _state$app4 === void 0 ? void 0 : (_state$app4$activeLay = _state$app4.activeLayers) === null || _state$app4$activeLay === void 0 ? void 0 : _state$app4$activeLay.basemap;
      });
      break;
    case 'streetView':
      layers = useSelector(function (state) {
        var _state$app5;
        return state === null || state === void 0 ? void 0 : (_state$app5 = state.app) === null || _state$app5 === void 0 ? void 0 : _state$app5.streetViewLayers;
      });
      activeLayers = useSelector(function (state) {
        var _state$app6, _state$app6$activeLay;
        return state === null || state === void 0 ? void 0 : (_state$app6 = state.app) === null || _state$app6 === void 0 ? void 0 : (_state$app6$activeLay = _state$app6.activeLayers) === null || _state$app6$activeLay === void 0 ? void 0 : _state$app6$activeLay.streetView;
      });
      break;
  }
  return /*#__PURE__*/React.createElement(LayersComponent, _extends({
    layers: layers,
    activeLayers: activeLayers,
    toggleLayer: function toggleLayer(id, group) {
      return dispatch(_toggleLayer({
        id: id,
        group: group
      }));
    }
  }, props));
};
Layers.propTypes = process.env.NODE_ENV !== "production" ? {
  group: PropTypes.string.isRequired
} : {};
export default Layers;